import { api } from './api';

const affiliationURL = '/affiliation';

export const affiliationApi = api.injectEndpoints({
  endpoints: builder => ({
    getAllAffiliations: builder.query({
      // params: { type: 'parents' } | { campId: '...' } | undefined (all)
      query: (params) => ({ url: affiliationURL, params }),
      providesTags: ['Affiliation'],
    }),
    createAffiliation: builder.mutation({
      query: body => ({ url: affiliationURL, method: 'POST', body }),
      invalidatesTags: ['Affiliation'],
    }),
    updateAffiliation: builder.mutation({
      query: ({ _id, ...body }) => ({ url: `${affiliationURL}/${_id}`, method: 'PUT', body }),
      invalidatesTags: ['Affiliation'],
    }),
    deleteAffiliation: builder.mutation({
      query: (id) => ({ url: `${affiliationURL}/${id}`, method: 'DELETE' }),
      invalidatesTags: ['Affiliation'],
    }),
  }),
});

export const {
  useGetAllAffiliationsQuery,
  useCreateAffiliationMutation,
  useUpdateAffiliationMutation,
  useDeleteAffiliationMutation,
} = affiliationApi;
